import { connect } from 'react-redux';
import FilesHierarchy, {
  IFilesHierarchyStateProps,
} from '../components/files/FilesHierarchy';
import { IApplicationState } from '@store';
import { withRouter, RouteComponentProps } from 'react-router';

type IMapStateToProps = Pick<IApplicationState, 'files'>;

type OwnProps = RouteComponentProps<{
  relativePath: string;
}>;

const mapStateToProps = (
  { files }: IMapStateToProps,
  ownProps: OwnProps
): IFilesHierarchyStateProps => {
  const relativePath = ownProps.match.params.relativePath;
  return {
    files: files.files,
    requestStatus: files.status,
    relativePath: relativePath,
  };
};

export default withRouter(connect(mapStateToProps)(FilesHierarchy));
